import {FormEvent, useState} from 'react';
import {IonContent, IonPage} from '@ionic/react';
import actions from '../api/resetPassword';
import {isValidEmail} from '../utilis/isValidEmail';
import UILogo from '../components/UICommon/UILogo';
import UIImage from '../components/UICommon/UIImage';
import UIStackedInput from '../components/UICommon/UIStackedInput';
import UIButton from '../components/UICommon/UIButton';
import UILoadingIndicator from '../components/UICommon/UILoadingIndicator';
import UIErrorIndicator from '../components/UICommon/UIErrorIndicator';

import img from '../assets/images/login.png';

const LoginPage: React.FC = () => {
  const initialValues = {success: false, error: false, errorMessage: ''};
  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState<string>();
  const [status, setStatus] = useState(initialValues);

  const submit = (event: FormEvent) => {
    event.preventDefault();
    const state = initialValues;

    if (!email) {
      state.errorMessage = ('Ange din e-postadress');
      setEmail('');
    } else if (!isValidEmail(email)) {
      state.errorMessage = ('E-postadressen är ogiltig');
    }

    if (!state.errorMessage) {
      setLoading(true);
      actions.requestPasswordReset(email!).then(() => {
        state.success = true;
      }).catch((error) => {
        state.error = true;
      }).finally(() => {
        setLoading(false);
        setStatus(state);
      });
    } else {
      setStatus(state);
    }
  };

  return (
    <IonPage>
      <IonContent>
        <div className='flex h-full bg-black-midnight md:bg-gray-login'>
          <div className='w-full md:w-1/2 flex flex-col justify-between p-8 md:px-20 md:pt-20'>
            <div className='h-1/2 flex flex-col z-10 justify-between'>
              <UILogo style='text-white md:text-navy-primary'/>
              <UIButton type='link' text='Gå tillbaka' link='/'
                style='text-left md:text-navy-primary text-lg underline'/>
              {loading && <UILoadingIndicator style='text-white md:text-navy-black'/>}
              {status.error && <UIErrorIndicator/>}
              <div className='font-Outfit font-semibold text-white md:text-navy-secondary pb-5'>
                <h1 className='text-2xl md:text-3xl'>Återställ ditt lösenord.</h1>
                <h2 className='text-sm md:text-base'>Fyll i din e-postadress för att återställa ditt lösenord.
                  Vi skickar en återställningslänk till din e-post.</h2>
              </div>
            </div>
            <div className='flex-grow flex flex-col'>
              { status.success ? (
                      <div className='text-green-700'>
                        Kolla din e -post och klicka på aktiveringslänken för att ändra ditt lösenord.</div>
                  ) : (
                  <form className='flex flex-col h-full' onSubmit={(e) => submit(e)}>
                    <div className='pb-8'>
                      <UIStackedInput text={email!} name='email' setText={setEmail}
                        labelText='E-postadress' style='bg-black-matte text-white caret-white' inputMode='email'
                        hideLabelOnMobile={true} placeholder='E-postadress' badInput={status.errorMessage}/>
                    </div>
                    <UIButton buttonType='submit' type='full' text='Skicka länk'
                      style="font-semibold 17 font-Manrope hidden md:block"/>
                    <UIButton buttonType='submit' type='full' text='Skicka länk' color='light'
                      style="font-semibold 17 font-Manrope round-20 md:hidden mt-auto"/>
                  </form>
                  )}
              <div className='mt-auto text-gray-primary font-Manrope text-sm
               font-semibold text-center w-full hidden md:block'>
                    @2022 SVERGIES REGISTRERADE TATUERARE
              </div>
            </div>
          </div>
          <div className='h-1/2 absolute w-full md:w-1/2 md:p-5 md:h-screen md:right-0 md:z-0'>
            <UIImage url={img} style='md:rounded-3xl'/>
          </div>
        </div>
      </IonContent>
    </IonPage>
  );
};

export default LoginPage;
